module.exports = __webpack_public_path__ + "img/fabric-placeholder.7b209a38.jpg";